<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3eh3qi/tc-custom/9781035831883.jpg?1718106414894" alt="This image is the cover for the book Shusha"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shusha
      </h1>
      <p class="bookDescription body article font2">
        <p>Shusha follows two complex women – an alluring Egyptian high priestess and a scandalous Victorian heiress – connected by a mysterious, supernatural bond across centuries. This historical fantasy follows the life of a young Egyptian girl, destined for greatness, whose path is mysteriously guided by a divine feline entity. Surrounded by palace intrigue, this bewitching priestess undergoes many trials and tribulations in the pursuit of ultimate divinity. Centuries later in Victorian London, wealthy young socialite Rose courts power in her own right, inheriting a lavish estate amidst whispers of foul play. As Rose develops a shadowy coterie of Egyptian servants and creates a subterranean shrine to honour artefacts from the ancient world, her eccentricities, and the mysterious influence of a past life provoke scandals amongst London’s elite circles. What is the secret behind the cosmic connection between these two complex women? The novel masterfully blends mysticism and historical realities, exploring themes of destiny and the unseen forces shaping our lives. Taylor’s narrative delicately balances the revelation of fate with a sense of intrigue, keeping the girl’s ultimate destiny shrouded in mystery, inviting readers to explore a world where myth and history converge.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ian Taylor
      </h2>
      
      <p class="authorDescription body article">Ian Taylor writes about an Egyptian girl who becomes a queen due to her goddess. The cat goddess based in ancient Egypt and being reborn in Victorian times.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8f9996b6